module.exports = __webpack_public_path__ + "img/material-symbols.d11df403.svg";